import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5599000e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "join-container" }
const _hoisted_2 = { class: "title--small text-centered" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "highlighted-text" }, "join!", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "nav-link shadow",
        id: "Join",
        to: "/join"
      }, {
        default: _withCtx(() => [
          _createTextVNode("I've heard enough - let me "),
          _hoisted_3
        ]),
        _: 1
      })
    ])
  ]))
}